const COPY_INDEX_PATTERN = /\s*\(\d+\)$/

/**
 * Returns `base` with the lowest free ` (N)` suffix (N starts at 1), given the
 * names already taken. Any trailing ` (N)` on `base` is stripped first, so
 * duplicating an already numbered copy increments the number (`Report (1)`
 * yields `Report (2)`) rather than nesting suffixes. Mirrors the backend
 * `next_available_copy_name` helper.
 */
export function nextAvailableCopyName(
  base: string,
  taken: Set<string>,
): string {
  const root = base.replace(COPY_INDEX_PATTERN, "").trim()
  let index = 1
  while (taken.has(`${root} (${index})`)) {
    index += 1
  }
  return `${root} (${index})`
}
